import { useQuery } from '@tanstack/react-query';

import { fetchAdminDashboard } from './client';
import { dashboardKeys } from './keys';

/**
 * useAdminDashboard — read-only fetch of the operations command-center payload.
 *
 * Replaces the legacy `dashboard/fetchAdminDashboard` thunk + slice. The
 * shape returned by the backend is unchanged.
 */
export function useAdminDashboard(limit: number = 5) {
  return useQuery({
    queryKey: dashboardKeys.adminWithLimit(limit),
    queryFn: () => fetchAdminDashboard(limit),
    // Dashboard data is moderately fresh — 60s aligns with the typical
    // refresh cadence operators expect when reloading the page.
    staleTime: 60_000,
    // ALWAYS re-pull when the command center is (re)opened. The dashboard is an
    // aggregate of many entities (meetings, quotes, leads, work orders…) that
    // are mutated on other screens; without this, navigating back here within
    // staleTime shows stale data (e.g. a meeting you just created is missing
    // until a hard refresh). Cached data shows instantly while it revalidates.
    refetchOnMount: 'always',
  });
}
